(() => {
  'use strict';
  if (window.yjWebsiteCallsInstalled) return;
  window.yjWebsiteCallsInstalled = true;
  const destination = 'AW-18249503891/hTGoCN2KuK0dEJOphf5D';
  const baseTag = 'AW-18249503891';
  const originalLinks = new Map();
  let started = false;
  let forwardingNumber = null;
  /* Canada needs a real "yes": marketingAllowed() alone is true before any choice when no banner applies. */
  const allowed = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed()) return false;
    const region = privacy.getRegion ? privacy.getRegion() : '';
    if (region && !region.startsWith('CA')) return true;
    const consent = privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : {};
    return consent.marketing === 'yes';
  };
  function clearGoogleStorage() {
    const host = location.hostname.replace(/^www\./, '');
    document.cookie.split('; ').forEach(entry => {
      const name = entry.split('=')[0];
      if (!/^(_ga|_gid|_gcl_|_gac_)/.test(name)) return;
      ['', '; domain=' + host, '; domain=.' + host].forEach(domain => {
        document.cookie = name + '=; Max-Age=0; path=/' + domain;
      });
    });
    try {
      Object.keys(localStorage).forEach(key => {
        if (/^(_gcl_|_gac_)/.test(key)) localStorage.removeItem(key);
      });
    } catch (_) {}
  }
  function applyNumber() {
    if (!allowed() || !forwardingNumber) return;
    document.querySelectorAll('a[href^="tel:"]').forEach(link => {
      const digits = link.getAttribute('href').replace(/\D/g, '');
      if (!originalLinks.has(link) && digits !== '15142459159' && digits !== '5142459159') return;
      if (!originalLinks.has(link)) {
        originalLinks.set(link, {href: link.getAttribute('href'), text: link.textContent});
      }
      link.setAttribute('href', 'tel:+' + forwardingNumber.mobile.replace(/\D/g, ''));
      link.textContent = forwardingNumber.formatted;
    });
  }
  function restoreNumbers() {
    originalLinks.forEach((original, link) => {
      link.setAttribute('href', original.href);
      link.textContent = original.text;
    });
    originalLinks.clear();
    forwardingNumber = null;
  }
  function sync() {
    if (!allowed()) {
      restoreNumbers();
      if (started && window.gtag) window.gtag('consent', 'update', {
        ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
      });
      clearGoogleStorage();
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
    window.gtag('consent', 'update', {
      ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted'
    });
    if (!started) {
      started = true;
      window.gtag('js', new Date());
      window.gtag('config', baseTag, {send_page_view: false});
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + baseTag;
        document.head.appendChild(script);
      }
    }
    window.gtag('config', destination, {
      phone_conversion_number: '(514) 245 - 9159',
      phone_conversion_callback: function(formatted, mobile) {
        if (!allowed() || !formatted || !mobile) return;
        forwardingNumber = {formatted: String(formatted), mobile: String(mobile)};
        applyNumber();
      },
      phone_conversion_options: {cache: false}
    });
  }
  document.addEventListener('DOMContentLoaded', applyNumber, {once: true});
  document.addEventListener('shopify:section:load', applyNumber);
  document.addEventListener('visitorConsentCollected', sync);
  if (window.Shopify && window.Shopify.customerPrivacy) sync();
  else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      if (!error) sync();
    });
  }
})();
